import { Box } from "@mui/material";
import React, { useEffect, useState } from "react";
import ArticleOutlinedIcon from "@mui/icons-material/ArticleOutlined";
import ImageOutlinedIcon from "@mui/icons-material/ImageOutlined";
import VideocamOutlinedIcon from '@mui/icons-material/VideocamOutlined';
import { useNavigate } from "react-router-dom";
import { useAppDispatch, useAppSelector } from "../../../store/hooks";
import {
  setIsGenerateImage,
  setIsGlobalSearch,
} from "../../../store/one-query/chatsSlice";
import UpgradePlanButton from "../../main-page/components/get-conversation/UpgradePlanButton";
import UserProfile from "../../main-page/components/get-conversation/UserProfile";
import { SuitesNavbarItem } from "./SuitesNavbarItem";
import "../Suites.css";
import { SignInRegisterButtons } from "../../../shared/SignIn&RegisterButtons";
import AvailablePackagesModal from "../../CreditsScenario/AvailablePackagesModal";
import AddCredits from "../../CreditsScenario/AddCredits";
interface SuitesSidebarProps {
  handleHideSidebar: () => void;
  hideSidebar: boolean;
}
const tooltipStyles = {
  tooltip: {
    sx: {
      bgcolor: "#E5E2E1",
      color: "#0B1216",
      fontSize: "11px",
      fontWeight: 500,
      padding: "8px 12px",
      borderRadius: "4px",
      boxShadow: "0px 4px 6px rgba(0, 0, 0, 0.1)",
    },
  },
  arrow: {
    sx: {
      color: "#E5E2E1",
    },
  },
};

export const SuitesNavbar = ({
  handleHideSidebar,
  hideSidebar,
}: SuitesSidebarProps) => {
  const dispatch = useAppDispatch();
  const navigate = useNavigate();
  const [activeSuitesApp, setActiveSuitesApp] = useState("");
  const [showAvailablePackages, setShowAvailablePackages] =useState<boolean>(false)
  const User = useAppSelector((s) => s.User);

  useEffect(() => {
    if (window.location.pathname.includes("text-suite")) {
      setActiveSuitesApp("Text");
      dispatch(setIsGenerateImage(false));
      dispatch(setIsGlobalSearch(false));
    } else if (window.location.pathname.includes("image-suite")) {
      setActiveSuitesApp("Image");
      dispatch(setIsGenerateImage(false));
      dispatch(setIsGlobalSearch(false));
    } else if (window.location.pathname.includes("video-suite")) {
      setActiveSuitesApp("Video");
      dispatch(setIsGenerateImage(false));
      dispatch(setIsGlobalSearch(false));
    }
  }, [window.location.pathname]);

  const SuitesApps = [
    {
      appName: "Text",
      appIcon: (
        <ArticleOutlinedIcon
          className={`app-icon ${activeSuitesApp === "Text" ? "active" : ""}`}
        sx={{ fontSize:"16px",}}
        />
      ),
    },
    {
      appName: "Image",
      appIcon: (
        <ImageOutlinedIcon
          className={`app-icon ${activeSuitesApp === "Image" ? "active" : ""}`}
        sx={{ fontSize:"16px",}}
        />
      ),
    },
    {
      appName: "Video",
      appIcon: (
        <VideocamOutlinedIcon
          className={`app-icon ${activeSuitesApp === "Video" ? "active" : ""}`}
          sx={{
            fontSize:"18px",
          }}
        />
      ),
    },
  ];

  const handleSetActiveSuitesApp = (appName: string) => {
    setActiveSuitesApp(appName);
    if (appName === "Text") {
      navigate("text-suite");
    } else if (appName === "Image") {
      navigate("image-suite");
    } else if (appName === "Video") {
      navigate("video-suite");
    }
  };

  return (
    <Box className={`suites-sidebar ${hideSidebar && "hide-sidebar"}`}>
      <Box className="suites-apps">
        <Box
          className="apps"
          sx={{ width: "100%", display: "flex", height: "100%", gap: "1rem" ,overflowX: "auto",
            scrollbarWidth: "none"}}
        >
          {SuitesApps.map((app) => (
            <Box
              sx={{ width: "13%", minWidth: "100px" }}
              key={app.appName}
              onClick={() => handleSetActiveSuitesApp(app.appName)}
            >
              <SuitesNavbarItem
                appTitle={app.appName}
                appIcon={app.appIcon}
                activeApp={activeSuitesApp}
              />
            </Box>
          ))}
        </Box>
        <Box
          sx={{
            width: "fit-content",
            maxWidth: "500px",
            display: "flex",
            flexDirection: "row",
            alignItems: "center",
            gap: "8px",
            justifyContent: "space-between",
            marginBottom: "8px",
            "@media (max-width: 900px)": {
              display: "none",
            },
          }}
        >
          <div>
             <AddCredits showAvailablePackages={showAvailablePackages} setShowAvailablePackages={setShowAvailablePackages}/>
          </div>
          {User.IsAuthenticated && !User.isSubscribed ? (
            <UpgradePlanButton />
          ) : !User.IsAuthenticated ? (
            <Box className="signin-actions">
              <SignInRegisterButtons />
            </Box>
          ) : (
            <Box></Box>
          )}
          {User.IsAuthenticated && <UserProfile />}
        </Box>
      </Box>
       {
          showAvailablePackages && (
             <AvailablePackagesModal show={showAvailablePackages} handleClose={()=>setShowAvailablePackages(false)}/>
          )
        }
    </Box>
  );
};
